const TESTS = {
    HA_BOT_PROPERTYDETAILS_WEB_V1: 'HA_BOT_PropertyDetails_Web_v1',
    EG_BOT_VRBO_PDP_VAP_WEB_V1: 'EG_BOT_Vrbo_PDP_VAP_Web_V1',
    HA_BOT_PROPERTYDETAILSVALAUNCH_V2: 'HA_BOT_PropertyDetailsVALaunch_v2',
    HA_BOT_Recommendations_V1: 'HA_BOT_Recommendations_V1',
    HA_BOT_WEB_BEDMAPSPRICERULES: 'HA_BOT_Web_BedMapsPriceRules',
    HA_PDP_BIZMETRICS: 'ha_pdp_bizmetrics',
    HA_GDPR_BANNER: 'ha_gdpr_banner',
    HA_IDA_LOGIN_TO_SAVE_TRIPBOARD: 'HA_IDA_LOGIN_TO_SAVE_TRIPBOARD',
    HA_IDA_PDP_CARD_TEST: 'HA_IDA_PDP_CARD_TEST',
    HA_IDA_PDP_GOOGLEONETAP: 'HA_IDA_PDP_GOOGLEONETAP',
    HA_IDA_V3_LOGIN_TEST: 'HA_IDA_V3_LOGIN_TEST',
    HA_INQUIRY_FORM_REDUNDANCIES_REMOVED: 'HA_Inquiry_Form_Redundancies_Removed',
    HA_PDP_PROPERTY_DESCRIPTION_FALLBACK: 'ha_pdp_property_description_fallback',
    HA_PDP_VIRTUAL_TOUR_VIEWER: 'ha_pdp_virtual_tour_viewer',
    HA_VIRTUAL_TOUR_VIEWER_PDP_MOBILE: 'ha_virtual_tour_viewer_pdp_mobile',
    HA_PULSE_TRIPBOARD_GRAPHQL_THROTTLE: 'ha_pulse_tripboard_graphql_throttle',
    HA_PULSE_TRIPBOARD_NEW_MODAL_TEST: 'ha_pulse_tripboard_new_modal_test',
    HA_PDP_MWEB_PERF_INSIGHTS: 'ha_pdp_mweb_perf_insights',
    HA_REACT_PRICE_DETAILS_: 'HA_REACT_PRICE_DETAILS_.*',
    PCSLPSDATAEXPERIMENT: 'pcsLpsDataExperiment',
    HA_PDP_REVIEWS_ON_DEMAND_TRANSLATION: 'ha_pdp_reviews_on_demand_translation',
    HA_PDP_RANKED_BADGES: 'ha_pdp_ranked_badges',
    HA_GX_PRE_BRAND_TRANSITION: 'HA_GX_PRE_BRAND_TRANSITION',
    HA_GX_POST_BRAND_TRANSITION: 'HA_GX_POST_BRAND_TRANSITION',
    REMOVE_PARTNER_NAME_AND_LOGO_FROM_PDP: 'remove_partner_name_and_logo_from_PDP',
    INLINE_PDP_VIRTUAL_TOUR: 'Inline_PDP_Virtual_Tour',
    HA_TYPEAHEAD_LID_SEARCH: 'HA_TYPEAHEAD_LID_SEARCH',
    HA_TYPEAHEAD_TWO_LINE_DISPLAY: 'ha_typeahead_two_line_display_v2',
    MESO_VRBO_DISPLAY_ADS: 'MESO_Vrbo_display_ads',
    HA_PDP_RECO_NEW_TAB: 'HA_PDP_RECO_NEW_TAB',
    HA_TOI_PDP_V1: 'ha_toi_pdp_v1',
    VRBO_AFFIRM_NO_PREQUAL: 'Vrbo_Affirm_noPrequal',
    HA_IDA_PDP_LOGIN_TO_BOOK: 'HA_IDA_PDP_LOGIN_TO_BOOK',
    HA_PTA_HEADER_LOGIN_COPY: 'HA_PTA_HEADER_LOGIN_COPY',
    HA_PDP_CGS_DESCRIPTION: 'ha_pdp_cgs_description',
    HA_PTA_SEARCHBOX_ADDGUESTPICKERONPDP: 'HA_PTA_SEARCHBOX_addGuestPickerOnPDP',
    HA_PDP_VIRTUAL_TOUR_HELPFULNESS: 'HA_PDP_virtual_tour_helpfulness',
    HA_VT_NEW_FLOOR_NAV_MODAL: 'HA_VT_New_Floor_Nav_Modal',
    HA_VT_DIRECT_NAVIGATION: 'HA_VT_Direct_Navigation',
    HA_VT_HOLDOUT_TEST: 'HA_VT_Holdout_Test',
    VRBO_SERP_PDP_COVID_BANNER: 'vrbo_serp_pdp_covid_banner',
    VRBO_WEB_SIMPLE_RIGHT_RAIL_DISPLAY: 'vrbo_web_simple_right_rail_display',
    VRBO_WEB_PDP_SPACES: 'vrbo_web_PDP_spaces',
    HA_PTA_SEARCHFORM_PDPDESKTOPTABLETWEB: 'HA_PTA_SEARCHFORM_PDPdesktoptabletweb',
    HA_PTA_SEARCHFORM_PDPMWEB: 'HA_PTA_SEARCHFORM_PDPmweb',
    VRBO_LANDING_PDP_REDIRECT_TO_SLP: 'VRBO_LANDING_PDPRedirectToSLP',
    VRBO_PDP_R2D2_QUERY: 'vrbo_pdp_r2d2_query',
    VRBO_PDP_DISPLAY_TRAVELER_SENTIMENTS: 'vrbo_pdp_display_traveler_sentiments',
    VRBO_PDP_R2D2_PLANB: 'vrbo_pdp_r2d2_planB',
    HA_PDP_FRAUD_PREVENTION_MSG_THROTTLE: 'ha_pdp_fraud_prevention_msg_throttle',
    HA_PDP_FRAUD_PREVENTION_MSG: 'ha_pdp_fraud_prevention_msg',
    VRBO_WEB_GLOBAL_MESSAGING_BANNER: 'vrbo_web_global_messaging_banner',
    HA_TRAVELER_HEADER_TRAY_MOBILE_APP: 'HA_TRAVELER_HEADER_TRAY_MOBILE_APP',
    VRBO_WEB_GLOBAL_MESSAGING_ALERT: 'vrbo_web_global_messaging_alert',
    VRBO_PRICEDETAILS_PAYMENTSCHEDULE: 'vrbo_PriceDetails_PaymentSchedule',
    HA_PTA_SEARCHBOX_ADD_AGE_OF_CHILDREN: 'HA_PTA_SEARCHBOX_addAgeOfChildren',
    HA_PTA_SEARCHBOX_HINT_TEXT_CHOOSING_DATES: 'HA_PTA_SEARCHBOX_hintTextChoosingDates',
    VRBO_LANDING_PDP_INDEXATION_POLICY_MVP: 'VRBO_LANDING_PDPIndexationPolicyMVP',
    VRBO_LANDING_EXPANDED_SEARCHFORM_ON_PDP: 'VRBO_LANDING_expandedSearchFormOnPDP',
    VRBO_PDP_REVIEW_HIGHLIGHTS_V1: 'vrbo_pdp_review_highlights_v1',
    HA_PDP_LOS_DISCOUNT_RIGHT_RAIL: 'HA_PDP_LOS_DISCOUNT_RIGHT_RAIL',
    HA_PDP_LOS_DISCOUNT_RIGHT_RAIL_EU: 'HA_PDP_LOS_DISCOUNT_RIGHT_RAIL_EU',
    VRBO_PDP_LINE_ITEMS_DISCOUNT: 'vrbo_pdp_line_items_discount',
    VRBO_PDP_REMOVE_OWNER_CAROUSEL: 'Vrbo_pdp_remove_owner_carousel'
};

const EVALUATE = Object.values(TESTS);
const EVALUATE_AND_LOG = [];

module.exports = {
    EVALUATE,
    EVALUATE_AND_LOG,
    ...TESTS
};
